import React from 'react';
import { Button } from '../../ui/Button/Button';
import { ModalShell } from '../../ui/ModalShell/ModalShell';
import type { ConfirmModalProps } from './types';

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
    heading,
    body,
    confirmLabel,
    cancelLabel,
    onConfirm,
    onCancel,
    modalTestId,
    testId,
    confirmBtnTestId,
    cancelBtnTestId,
}) => (
    <ModalShell
        heading={heading}
        onClose={onCancel}
        dismissAriaLabel={cancelLabel}
        rootTestId={modalTestId ?? testId}
        panelClassName="bg-surface-elevated ring-1 ring-line-subtle rounded-lg shadow-strong w-full max-w-md mx-l p-xl flex flex-col gap-l"
        footer={
            <>
                <Button
                    variant="secondary"
                    data-testid={cancelBtnTestId ?? 'confirm-modal-cancel-btn'}
                    type="button"
                    onClick={onCancel}
                >
                    {cancelLabel}
                </Button>
                <Button data-testid={confirmBtnTestId ?? 'confirm-modal-confirm-btn'} type="button" onClick={onConfirm}>
                    {confirmLabel}
                </Button>
            </>
        }
    >
        <p className="text-s text-content-secondary">{body}</p>
    </ModalShell>
);
